<script setup lang="ts">

import { ref } from "vue";
import dayjs from "dayjs";
import type { ConfigureConditionViewModel } from "..";

const model = defineModel<ConfigureConditionViewModel>( { required: true } );
const condition = model.value.condition;
const dueDate = condition.date.next.isValid() ? condition.date.next : dayjs().add( 1, 'day');
const selectedDate = ref( dueDate.toDate() );

</script>

<template>

    <div class="text-base text-center flex flex-col pb-10 tracking-wider">

        <h1 class="leading-tight my-6 px-4 lg:px-8">
            When would you like to be reminded?
        </h1>
        
        <v-date-picker v-model="selectedDate"
                       :min="dayjs().toISOString()"
                       hide-header
                       show-adjacent-months
                       width="100%"
                       color="#14b2cd"
                       bg-color="transparent"
                       class="!rounded-none"
                       @update:model-value="(date) => model.onSelectNext( dayjs( date ).add( 12, 'hour' ) )">
        </v-date-picker>

    </div>

</template>
